import { Injectable } from '@angular/core';
import { ShopSettings } from '../../../libs/proto/shop_pb';
import { BinaryWriter } from 'google-protobuf';

@Injectable({
  providedIn: 'root'
})
export class ShopSettingsConversionService {

  constructor() { }

  ToStorage(req: ShopSettings) {
    const w = new BinaryWriter();
    ShopSettings.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  FromStorage(data: any, callback: (c: ShopSettings, errorConvert: any) => void) {
    try {
      callback( ShopSettings.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }
}
